import React, { Component } from 'react';
import './consultoria.css';
import scrollToComponent from 'react-scroll-to-component';

export default class Consultoria extends Component {
  constructor(props){
    super(props);
    this.state={

    }
    this.routeParam = this.props.match.params
  }
  componentWillMount(){
    
  }
  componentWillReceiveProps(np){
    if(np.match.params.position!==this.routeParam.position){
      console.log(np.match.params.position);
      scrollToComponent(this.refs[np.match.params.position],{
        offset: -55,
        align:"top",
        duration: 500
      });
    }
    if(JSON.stringify(np.match.params)!==JSON.stringify(this.routeParam)){
      this.routeParam = np.match.params
    }
  }
  render() {
    return (
      <div className="navMargin container">
        <h2 ref="libro">libro</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
        <h2 ref="video">video</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
        <h2 ref="correccion">correccion</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
        <h2 ref="edicion">edicion</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
        <h2 ref="fotografia">fotografia</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
        <h2 ref="comunicacion">comunicacion</h2>
        <div style={{height:"400px",backgroundColor:"red"}}></div>
      </div>
    );
  }
  componentDidMount(){
    var self=this;
    setTimeout(()=>{
      scrollToComponent(self.refs[self.routeParam.position],{
        offset: -50,
        align:"top",
        duration: 500
      });
    },500)
  }
  componentWillUnmount(){

  }
}


// WEBPACK FOOTER //
// ./src/views/consultoria/index.js